/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PrevVenuePage from './PrevVenuePage';

export default function VenuePageWrapper(props) {
    return <PrevVenuePage {...props} />;
}
